import _typeof from "@babel/runtime/helpers/esm/typeof";
/**
 * 空页面配置数据
 */
export var emptyConfig = {
  network: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i3/O1CN01wlrzwP20XTGoJ9tXr_!!6000000006859-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i4/O1CN01MgOpLP1Cyk4E1193E_!!6000000000150-2-tps-360-360.png'
    },
    title: '网络链接发生问题',
    describe: '请检查网络设置或刷新页面重试',
    btnName: '刷新',
    define: '网络错误'
  },
  permission: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i3/O1CN01mDxFPu28po3MpalG7_!!6000000007982-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i2/O1CN01qHUuko1JrbCNQrZZB_!!6000000001082-2-tps-360-360.png'
    },
    title: '暂无权限',
    define: '暂无权限'
  },
  exception: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i3/O1CN01IckYXn1qBLzD0z1Q4_!!6000000005457-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i4/O1CN01SsOXZU1z8S1JTOQqe_!!6000000006669-2-tps-360-360.png'
    },
    title: '页面异常',
    describe: '刷新页面重试',
    btnName: '刷新',
    define: '页面异常'
  },
  search: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i4/O1CN01JkeMte1lQrJhvRWtj_!!6000000004814-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i4/O1CN01WbWzDm27ZUKFvK5Ol_!!6000000007811-2-tps-360-360.png'
    },
    define: '无搜索结果'
  },
  noContent: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i4/O1CN019V5Laa1JL54vlyQ2F_!!6000000001011-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i1/O1CN01DvWzRb1Ur6XoyvgZL_!!6000000002570-2-tps-360-360.png'
    },
    title: '暂无内容',
    define: '暂无内容'
  },
  recycleBinCleared: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i1/O1CN01ziUxMb1M7kOaUtZPR_!!6000000001388-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i3/O1CN01VoaAoQ1K6iGmKa74O_!!6000000001115-2-tps-360-360.png'
    },
    title: '回收站已清空',
    define: '回收站已清空'
  },
  uploadFile: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i4/O1CN01JjpgTk1rcfDckjoXY_!!6000000005652-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i1/O1CN01i5ImSX1WwGElLQuMi_!!6000000002852-2-tps-360-360.png'
    },
    define: '上传文件'
  },
  noConv: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i2/O1CN01C3ul5k1t8YPgLLrbu_!!6000000005857-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i1/O1CN01AkhJ8h1w8xc5SlRgb_!!6000000006264-2-tps-360-360.png'
    },
    define: '暂无会话'
  },
  messageRead: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i3/O1CN01nbwvFI1S4REDPIVLh_!!6000000002193-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i1/O1CN01BcDAML1dav5mz7Qlb_!!6000000003753-2-tps-360-360.png'
    },
    define: '已读'
  },
  messageUnread: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i1/O1CN011E2G5c1SvZAiipdYB_!!6000000002309-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i4/O1CN017O45lA2AAhk4NMyeo_!!6000000008163-2-tps-360-360.png'
    },
    define: '未读'
  },
  noNotice: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i1/O1CN012Tnahh1uEL1zqqhuP_!!6000000006005-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i2/O1CN01zubcTZ1jsg8vnjO9D_!!6000000004604-2-tps-360-360.png'
    },
    define: '暂无公告'
  },
  noTodoList: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i4/O1CN01YdViSE1Jr8nvwjh42_!!6000000001081-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i3/O1CN01h02OtN1DscO1Sr6wp_!!6000000000272-2-tps-360-360.png'
    },
    define: '暂无待办'
  },
  noFile: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i3/O1CN01qqtPea1Er4fQOTx76_!!6000000000404-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i4/O1CN011C8Cel1Cluye2kv3v_!!6000000000122-2-tps-360-360.png'
    },
    define: '暂无文件'
  },
  noSchedule: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i4/O1CN01s6VmHM1MqdD4ybUHR_!!6000000001486-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i2/O1CN01HjNeUA1NpXsxdmEs3_!!6000000001619-2-tps-360-360.png'
    },
    define: '暂无日程'
  },
  noLive: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i1/O1CN01sxDsJ31R2mAzIdTNV_!!6000000002054-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i4/O1CN01IjdMAu29g1Ci2hiV6_!!6000000008096-2-tps-360-360.png'
    },
    define: '暂无直播'
  },
  noDoc: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i1/O1CN01O07A5C24qwZa2APUG_!!6000000007443-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i2/O1CN01JVpugc2A72ZUJinqB_!!6000000008155-2-tps-360-360.png'
    },
    define: '暂无文档'
  },
  noComments: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i3/O1CN015tfo0P1FTXwC42HDO_!!6000000000488-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i4/O1CN01uDw4Yo1FJTDsrE6AM_!!6000000000466-2-tps-360-360.png'
    },
    define: '暂无评论'
  },
  noApproval: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i4/O1CN01CyaScD1L12zEBxBfY_!!6000000001238-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i1/O1CN01txLGm51tlU4wh8f9w_!!6000000005942-2-tps-360-360.png'
    },
    define: '印章为空/暂无审批'
  },
  noRecord: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i1/O1CN01D5M5DI28wDb8YPo5P_!!6000000007996-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i1/O1CN013iROrR1dO5zzAlz6y_!!6000000003725-2-tps-360-360.png'
    },
    define: '记录为空'
  },
  noMeeting: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i2/O1CN01Sj1SSj1F4M9YwfvdJ_!!6000000000433-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i2/O1CN01jXcxwM1PQvpgx1jVL_!!6000000001836-2-tps-360-360.png'
    },
    define: '无会议'
  },
  noDevice: {
    img: {
      light: 'https://img.alicdn.com/imgextra/i4/O1CN0162dljb1npFdvLtMZ1_!!6000000005138-2-tps-360-360.png',
      dark: 'https://img.alicdn.com/imgextra/i4/O1CN01nxBySe1z1a4rFQXwk_!!6000000006654-2-tps-360-360.png'
    },
    define: '设备为空'
  }
};
export var prefersDarkMode = function prefersDarkMode() {
  var theme = 'light';
  try {
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.documentElement.getAttribute('data-dingtalk-theme') === 'dark') {
      theme = 'dark';
    }
  } catch (ex) {}
  return theme === 'dark';
};
export var getEmptyPageConfigByType = function getEmptyPageConfigByType(emptyPageTypeDefMap) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'noContent';
  var imgSrc;
  var emptyPageDef = emptyPageTypeDefMap[type];
  if (type && emptyPageTypeDefMap[type]) {
    var typeImg = emptyPageDef.img;
    if (typeof typeImg === 'string') {
      imgSrc = typeImg;
    } else if (_typeof(typeImg) === 'object') {
      imgSrc = prefersDarkMode() ? typeImg.dark : typeImg.light;
    }
  }
  return {
    imgSrc: imgSrc,
    title: emptyPageDef && emptyPageDef.title || '',
    desc: emptyPageDef && emptyPageDef.describe || '',
    btnName: emptyPageDef && emptyPageDef.btnName || ''
  };
};